import {styled} from '@material-ui/styles';
import Button from '@material-ui/core/Button';

export default styled(Button)({
    textDecoration: 'underline',
    '&:hover': {
        textDecoration: 'underline',
    },
});
